import {
  createBrowserRouter,
  Navigate,
  RouteObject
} from 'react-router-dom';


import { RootLayout } from './RootLayout';

import * as auth from './auth';
import * as external from './external';
import * as organization from './organization';
import * as superAdmin from './superAdmin';



export const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <RootLayout />
    ),
    errorElement: <div>Error!</div>,
    children: [
      organization.root,
      superAdmin.root,
      external.root,
      {
        path: '',
        element: <Navigate to='organization/projects' />
      }
    ]
  },
  auth.root
  // theme.root
];

export const router = createBrowserRouter(routes);



